"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2020, 2022 - 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
const ui_react_1 = require("@aws-amplify/ui-react");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const core_1 = require("@toolpad/core");
const react_router_1 = require("@toolpad/core/react-router");
const react_1 = require("react");
const React = require("react");
const react_router_2 = require("react-router");
const api_1 = require("../api");
const BRANDING = {
    title: "IVMS Online",
    logo: React.createElement("img", { src: "/favicon.png", alt: "IVMS Online" }),
};
const BaseApplication = () => {
    var _a, _b;
    const { user, signOut } = (0, ui_react_1.useAuthenticator)(context => [context.user]);
    const [me, setMe] = (0, react_1.useState)();
    const [vessels, setVessels] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const request = api_1.api.graphql({
            query: api_1.meQuery,
        })
            .then(response => {
            setMe(response.data.me);
            setVessels(response.data.listVessels.vessels);
        });
        return () => {
            api_1.api.cancel(request);
        };
    }, [user]);
    const navigation = [
        {
            title: "Overview",
            icon: React.createElement(icons_material_1.Dashboard, null),
        },
        ...vessels.map(vessel => {
            var _a;
            // this is always the first link
            const children = [
                {
                    title: "Status",
                    segment: "",
                },
            ];
            // this is why it's easier to do in reverse order
            // TODO: when vessel is online, add children from live view (/live)
            children.push(...vessel.embeds.map((embed, embedKey) => ({
                title: embed.title,
                segment: `dashboards/${embedKey}`,
            })));
            return {
                title: (_a = vessel.label) !== null && _a !== void 0 ? _a : vessel.name,
                segment: `vessels/${vessel.vesselId}`,
                icon: React.createElement(icons_material_1.DirectionsBoat, null),
                children,
            };
        }),
    ];
    // we always have this data - entire Application is guarded by Amplify
    const email = (_b = (_a = user.signInDetails) === null || _a === void 0 ? void 0 : _a.loginId) !== null && _b !== void 0 ? _b : "";
    const session = {
        user: {
            id: user.userId,
            name: me === null || me === void 0 ? void 0 : me.customer.name,
            image: me === null || me === void 0 ? void 0 : me.customer.logo,
            email,
        },
    };
    return React.createElement(react_router_1.ReactRouterAppProvider, { branding: BRANDING, navigation: navigation, session: session, authentication: {
            signOut,
            // not used, we have Amplify' Cognito
            signIn: () => null,
        } },
        React.createElement(material_1.CssBaseline, null),
        React.createElement(core_1.DashboardLayout, { disableCollapsibleSidebar: true },
            React.createElement(core_1.PageContainer, { maxWidth: false },
                React.createElement(react_router_2.Outlet, null))));
};
exports.Application = (0, ui_react_1.withAuthenticator)(BaseApplication, {
    hideSignUp: true,
});
